import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TuiButton, TuiDataList, TuiDialog } from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiFilterByInputPipe,
  TuiStringifyContentPipe,
} from "@taiga-ui/kit";
import {
  TuiComboBoxModule,
  TuiTextfieldControllerModule,
} from "@taiga-ui/legacy";
import { formatClientIdentifier } from "../../utils/client-identifier";

const ALL_TYPES = ["Registered", "Unregistered", "Inward"] as const;

@Component({
  selector: "app-change-client-type-panel",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TuiButton,
    TuiDataList,
    TuiDialog,
    TuiComboBoxModule,
    TuiDataListWrapper,
    TuiFilterByInputPipe,
    TuiStringifyContentPipe,
    TuiTextfieldControllerModule,
  ],
  templateUrl: "./change-client-type-panel.component.html",
})
export class ChangeClientTypePanelComponent implements OnChanges {
  @Input() open = false;
  @Input() client: { _id?: string; name?: string; clientType?: string } | null =
    null;
  @Input() busy = false;

  @Output() openChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  targetType: string | null = null;
  targetOptions: string[] = [];

  readonly stringifyType = (value: string | null): string => value ?? "";

  ngOnChanges(): void {
    const current = this.client?.clientType || "Registered";
    this.targetOptions = ALL_TYPES.filter((t) => t !== current);
    if (this.targetType && !this.targetOptions.includes(this.targetType)) {
      this.targetType = this.targetOptions[0] ?? null;
    } else if (!this.targetType && this.targetOptions.length) {
      this.targetType = this.targetOptions[0];
    }
  }

  clientLabel(): string {
    if (!this.client) return "";
    const id = formatClientIdentifier(this.client);
    const name = this.client.name || "";
    return id ? `${id} — ${name}` : name;
  }

  onConfirm(): void {
    if (!this.targetType || this.busy) return;
    this.confirm.emit(this.targetType);
  }

  onCancel(): void {
    this.open = false;
    this.openChange.emit(false);
    this.cancel.emit();
  }

  onDialogClose(): void {
    this.onCancel();
  }
}
